export default function debounce(function_, delay = 300) {
  let timer = null;
  return function () {
    clearTimeout(timer);
    const arguments_ = arguments;
    const that = this;
    timer = setTimeout(function () {
      function_.apply(that, arguments_);
    }, delay);
  };
}
